function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useState, useRef, useCallback, useEffect } from 'react';
import { useMounted, noop } from '@adsk/alloy-helpers';

function useVisibility(_ref) {
  var controlledShow = _ref.show,
      _ref$onHide = _ref.onHide,
      onHideProp = _ref$onHide === void 0 ? noop : _ref$onHide,
      _ref$onShow = _ref.onShow,
      onShowProp = _ref$onShow === void 0 ? noop : _ref$onShow,
      delayShow = _ref.delayShow,
      delayHide = _ref.delayHide;
  var isMountedRef = useMounted();

  var _useState = useState(controlledShow !== undefined),
      _useState2 = _slicedToArray(_useState, 2),
      isControlled = _useState2[0],
      setIsControlled = _useState2[1];

  var _useState3 = useState(controlledShow || false),
      _useState4 = _slicedToArray(_useState3, 2),
      show = _useState4[0],
      setShow = _useState4[1];

  var timeoutShowRef = useRef();
  var timeoutHideRef = useRef();
  var handleShow = useCallback(function () {
    return isControlled ? onShowProp() : setShow(true);
  }, [isControlled, onShowProp]);
  var handleHide = useCallback(function () {
    return isControlled ? onHideProp() : setShow(false);
  }, [isControlled, onHideProp]);
  var controlledHandleToggle = useCallback(function () {
    return show ? onHideProp() : onShowProp();
  }, [show, onHideProp, onShowProp]);
  var handleToggle = useCallback(function () {
    return setShow(!show);
  }, [show]);
  useEffect(function () {
    setIsControlled(controlledShow !== undefined);
  }, [controlledShow]);

  var onShow = function onShow() {
    clearTimeout(timeoutShowRef.current);
    clearTimeout(timeoutHideRef.current);
    timeoutShowRef.current = setTimeout(function () {
      if (isMountedRef.current) {
        onShowProp();
        handleShow();
      }
    }, delayShow);
  };

  var onHide = function onHide() {
    clearTimeout(timeoutShowRef.current);
    clearTimeout(timeoutHideRef.current);
    timeoutHideRef.current = setTimeout(function () {
      if (isMountedRef.current) {
        onHideProp();
        handleHide();
      }
    }, delayHide);
  };

  return {
    show: isControlled ? !!controlledShow : show,
    onHide: onHide,
    onShow: onShow,
    handleShow: handleShow,
    handleHide: handleHide,
    handleToggle: isControlled ? controlledHandleToggle : handleToggle
  };
}

export default useVisibility;
//# sourceMappingURL=useVisibility.js.map